(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[936],{

/***/ 862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/[boardType]/[boardSlug]",
      function () {
        return __webpack_require__(2581);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9563);
/* harmony import */ var _BackButton_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6749);
/* harmony import */ var _BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5__);







function BackButton(param) {
    var fallback = param.fallback, className = param.className;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var currentSite = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_SitesContextProvider__WEBPACK_IMPORTED_MODULE_4__/* .SitesContext */ .y).currentSite;
    var handleClick = function() {
        router.back();
    // todo: ideally we could use the 'fallback' prop to navigate to if we don't
    // have a 'back' state (i.e. new tab directly to URL)
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default().container), className),
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_BackButton_module_css__WEBPACK_IMPORTED_MODULE_5___default().btn)
        })
    });
}
BackButton.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    fallback: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
BackButton.defaultProps = {
    className: "",
    fallback: null
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 2657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CloudinaryMedia; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/CloudinaryMedia/CloudinaryVideo/CloudinaryVideo.module.css
var CloudinaryVideo_module = __webpack_require__(3725);
var CloudinaryVideo_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryVideo_module);
;// CONCATENATED MODULE: ./components/CloudinaryMedia/CloudinaryVideo/index.js





// import cloudinaryUrl from 'helpers/cloudinaryUrl'

// NOTE: Cloudinary is becoming too expensive to use for the client.
// With so much media and primarily the bandwidth being too high we have to remove
// video assets being served for now.
function CloudinaryVideo(param) {
    var videos = param.videos, videoAutoplay = param.videoAutoplay, videoLoop = param.videoLoop, videoEnded = param.videoEnded, className = param.className;
    if ((videos === null || videos === void 0 ? void 0 : videos.length) < 1) return null;
    var ref = (0,react.useState)(false), inProp = ref[0], setInProp = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        className: classnames_default()((CloudinaryVideo_module_default()).container, className, (0,_define_property/* default */.Z)({}, (CloudinaryVideo_module_default()).loaded, inProp === true)),
        playsInline: true,
        autoPlay: videoAutoplay === true,
        muted: true,
        loop: videoLoop,
        // controls
        onEnded: function() {
            return videoEnded();
        },
        onLoadedData: function() {
            return setInProp(true);
        },
        children: videos.map(function(param) {
            var url = param.url, type = param.type;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                src: url,
                type: type
            }, url);
        })
    });
}
CloudinaryVideo.propTypes = {
    videos: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        type: (prop_types_default()).string,
        params: (prop_types_default()).string
    })),
    videoAutoplay: (prop_types_default()).bool,
    videoLoop: (prop_types_default()).bool,
    videoEnded: (prop_types_default()).func,
    className: (prop_types_default()).string
};
CloudinaryVideo.defaultProps = {
    videos: [
        {
            url: "",
            type: "",
            params: ""
        }, 
    ],
    videoAutoplay: true,
    videoLoop: false,
    videoEnded: function() {},
    className: ""
};
/* harmony default export */ var CloudinaryMedia_CloudinaryVideo = (CloudinaryVideo);

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(7821);
// EXTERNAL MODULE: ./helpers/isModellinkSite.js
var isModellinkSite = __webpack_require__(2084);
;// CONCATENATED MODULE: ./helpers/cloudinaryUrl.js


function cloudinaryUrl(type, url, params) {
    var trimUrl = url.replace(/https:\/\/cms-dev*\.selectmodel\.com\/([^/]+\/)*wp-content\/uploads\//, "").replace(/https:\/\/cms-new*\.selectmodel\.com\/([^/]+\/)*wp-content\/uploads\//, "").replace(/https:\/\/cms-test*\.selectmodel\.com\/([^/]+\/)*wp-content\/uploads\//, "").replace(/https:\/\/([\w]+\.)?cms\.selectmodel\.com\/([^/]+\/)*wp-content\/uploads\//, "");
    var folder = (0,isModellinkSite/* default */.Z)() ? "wp-modellink" : "wp-select-model";
    var setParams = params ? "/".concat(params) : "";
    return "".concat(constants/* CLOUDINARY_URL */.uA, "/").concat(type, "/upload").concat(setParams, "/").concat(folder, "/").concat(trimUrl);
}

// EXTERNAL MODULE: ./components/CloudinaryMedia/CloudinaryImage/CloudinaryImage.module.css
var CloudinaryImage_module = __webpack_require__(4027);
var CloudinaryImage_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryImage_module);
;// CONCATENATED MODULE: ./components/CloudinaryMedia/CloudinaryImage/index.js







function CloudinaryImage(param) {
    var images = param.images, className = param.className;
    if ((images === null || images === void 0 ? void 0 : images.length) < 1) return null;
    var ref = (0,react.useState)(false), inProp = ref[0], setInProp = ref[1];
    var setImage1 = images[0] || null;
    var setImage2 = images[1] || null;
    var setImage1Params = (setImage1 === null || setImage1 === void 0 ? void 0 : setImage1.params) || null;
    var setImage2Params = (setImage2 === null || setImage2 === void 0 ? void 0 : setImage2.params) || null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        className: classnames_default()((CloudinaryImage_module_default()).container, className, (0,_define_property/* default */.Z)({}, (CloudinaryImage_module_default()).loaded, inProp === true)),
        onLoad: function() {
            return setInProp(true);
        },
        children: [
            (setImage2 === null || setImage2 === void 0 ? void 0 : setImage2.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                srcSet: cloudinaryUrl("image", setImage2.url, setImage2Params),
                media: "(min-width: 900px)"
            }),
            (setImage1 === null || setImage1 === void 0 ? void 0 : setImage1.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: cloudinaryUrl("image", setImage1.url, setImage1Params),
                alt: setImage1 === null || setImage1 === void 0 ? void 0 : setImage1.alt
            })
        ]
    });
}
CloudinaryImage.propTypes = {
    images: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        alt: (prop_types_default()).string,
        params: (prop_types_default()).string
    })),
    className: (prop_types_default()).string
};
CloudinaryImage.defaultProps = {
    images: [
        {
            url: "",
            alt: "",
            params: ""
        }, 
    ],
    className: ""
};
/* harmony default export */ var CloudinaryMedia_CloudinaryImage = (CloudinaryImage);

// EXTERNAL MODULE: ./components/CloudinaryMedia/CloudinaryMedia.module.css
var CloudinaryMedia_module = __webpack_require__(1130);
var CloudinaryMedia_module_default = /*#__PURE__*/__webpack_require__.n(CloudinaryMedia_module);
;// CONCATENATED MODULE: ./components/CloudinaryMedia/index.js







function CloudinaryMedia(param) {
    var videos = param.videos, videoLoop = param.videoLoop, videoEnded = param.videoEnded, videoAutoplay = param.videoAutoplay, images = param.images, noLazy = param.noLazy, className = param.className;
    var ref, ref1;
    var media = null;
    if (videos === null || videos === void 0 ? void 0 : (ref = videos[0]) === null || ref === void 0 ? void 0 : ref.url) {
        media = /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia_CloudinaryVideo, {
            videos: videos,
            videoAutoplay: videoAutoplay,
            videoLoop: videoLoop,
            videoEnded: videoEnded
        });
    } else if (images === null || images === void 0 ? void 0 : (ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.url) {
        media = /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryMedia_CloudinaryImage, {
            images: images
        });
    }
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((CloudinaryMedia_module_default()).container, className),
        children: media
    });
    return noLazy ? content : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
        offset: 1000,
        once: true,
        children: content
    });
}
CloudinaryMedia.propTypes = {
    videos: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        type: (prop_types_default()).string,
        params: (prop_types_default()).string
    })),
    videoAutoplay: (prop_types_default()).bool,
    videoLoop: (prop_types_default()).bool,
    videoEnded: (prop_types_default()).func,
    images: prop_types_default().arrayOf(prop_types_default().shape({
        url: (prop_types_default()).string,
        alt: (prop_types_default()).string,
        params: (prop_types_default()).string
    })),
    noLazy: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
CloudinaryMedia.defaultProps = {
    videos: [
        {
            url: "",
            type: "",
            params: ""
        }, 
    ],
    videoAutoplay: true,
    videoLoop: false,
    videoEnded: function() {},
    images: [
        {
            url: "",
            alt: "",
            params: ""
        }, 
    ],
    noLazy: false,
    className: ""
};
/* harmony default export */ var components_CloudinaryMedia = (CloudinaryMedia);


/***/ }),

/***/ 3825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/detect-browser/es/index.js
var es = __webpack_require__(3631);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/OutdatedBrowser/OutdatedBrowser.module.css
var OutdatedBrowser_module = __webpack_require__(5193);
var OutdatedBrowser_module_default = /*#__PURE__*/__webpack_require__.n(OutdatedBrowser_module);
;// CONCATENATED MODULE: ./components/OutdatedBrowser/index.js




function OutdatedBrowser(param) {
    var visible = param.visible;
    var ref = (0,react.useState)(visible), mounted = ref[0], setMounted = ref[1];
    var handleClick = function() {
        setMounted(false);
    };
    if (!mounted) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OutdatedBrowser_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (OutdatedBrowser_module_default()).title,
                children: "Your browser is out-of-date!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (OutdatedBrowser_module_default()).text,
                children: "Please update your browser to view this website correctly."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://browser-update.org/update-browser.html",
                target: "_blank",
                rel: "noopener noreferrer",
                className: (OutdatedBrowser_module_default()).link,
                children: "Update my browser"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (OutdatedBrowser_module_default()).btn,
                onClick: handleClick
            })
        ]
    });
}
OutdatedBrowser.propTypes = {
    visible: (prop_types_default()).bool
};
OutdatedBrowser.defaultProps = {
    visible: false
};
/* harmony default export */ var components_OutdatedBrowser = (OutdatedBrowser);

// EXTERNAL MODULE: ./components/Footer/index.js + 1 modules
var Footer = __webpack_require__(6195);
// EXTERNAL MODULE: ./components/Layout/Layout.module.css
var Layout_module = __webpack_require__(1627);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
;// CONCATENATED MODULE: ./components/Layout/index.js







function Layout(param) {
    var children = param.children, footerLess = param.footerLess, className = param.className, globalSettings = param.globalSettings, contentClassName = param.contentClassName;
    var browser = (0,es/* detect */.qY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OutdatedBrowser, {
                visible: browser && browser.name === "ie"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "layout",
                className: classnames_default()((Layout_module_default()).main, contentClassName),
                children: children
            }),
            !footerLess && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                globalSettings: globalSettings
            })
        ]
    });
}
Layout.propTypes = {
    className: (prop_types_default()).string,
    footerLess: (prop_types_default()).bool,
    globalSettings: (prop_types_default()).object,
    contentClassName: (prop_types_default()).string
};
Layout.defaultProps = {
    footerLess: false,
    className: "",
    globalSettings: {},
    contentClassName: ""
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 8115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6066);






function SliderBlock(param) {
    var parentRef = param.parentRef, setKey = param.setKey, settings = param.settings, textColour = param.textColour, className = param.className, children = param.children;
    var defaultSettings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                children: dots
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var dots = document.querySelectorAll(".slick-dots li");
        if ((dots === null || dots === void 0 ? void 0 : dots.length) > 0) {
            dots.forEach(function(e) {
                e.style.backgroundColor = textColour;
            });
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: parentRef
    }, settings ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, settings) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, defaultSettings)), {
        className: className,
        children: children
    }), setKey);
}
SliderBlock.propTypes = {
    parentRef: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    setKey: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    settings: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    textColour: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
};
SliderBlock.defaultProps = {
    parentRef: {},
    setKey: null,
    settings: {},
    textColour: "",
    className: "",
    children: null
};
/* harmony default export */ __webpack_exports__["Z"] = (SliderBlock);


/***/ }),

/***/ 6653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(662);
/* harmony import */ var hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(698);
/* harmony import */ var components_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5641);
/* harmony import */ var components_SliderBlock__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8115);
/* harmony import */ var components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2657);
/* harmony import */ var _SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7764);
/* harmony import */ var _SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10__);












function SliderCover(param) {
    var title = param.title, covers = param.covers, coverTitle = param.coverTitle, noLink = param.noLink, className = param.className;
    var ref;
    if ((covers === null || covers === void 0 ? void 0 : covers.length) < 0) return null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), progress = ref1[0], setProgress = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), timeoutId = ref2[0], setTimeoutId = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), locationTimeoutId = ref3[0], setLocationTimeoutId = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), videoTimeoutId = ref4[0], setVideoTimeoutId = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sliderColour = ref5[0], setSliderColour = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), sliderMobileColour = ref6[0], setSliderMobileColour = ref6[1];
    var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var setSliderLength = covers.length;
    var windowSize = (0,hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var isDesktop = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) >= 900;
    var isMobile = (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) < 900;
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(timeoutId);
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(locationTimeoutId);
    (0,hooks_useClearTimeout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(videoTimeoutId);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var doc = document.documentElement;
        var headerAttr = "data-header-color";
        if (isMobile && (router.pathname === "/[site]/[boardType]" || router.pathname === "/[site]/[boardType]/[boardSlug]") || isMobile && sliderMobileColour === "dark") {
            doc.setAttribute(headerAttr, "dark");
        } else if (isMobile && sliderMobileColour === "light" || isDesktop && sliderColour === "light") {
            doc.setAttribute(headerAttr, "light");
        } else if (isDesktop && sliderColour === "light-dark-logo") {
            doc.setAttribute(headerAttr, "light-ui-dark-logo");
        } else if (isDesktop && sliderColour === "dark-light-logo") {
            doc.setAttribute(headerAttr, "dark-ui-light-logo");
        }
        return function() {
            doc.removeAttribute(headerAttr);
        };
    }, [
        isMobile,
        sliderColour,
        sliderMobileColour
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        //TODO: Quickly added a random timeout to try and play videos
        // after a location change. Need to find a proper way to resolve
        // when time is allocated
        return function() {
            var locationTimeoutId = setTimeout(function() {
                playVideo();
            }, 2000);
            setLocationTimeoutId(locationTimeoutId);
        };
    }, [
        router
    ]);
    var sliderSettings = {
        fade: true,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        onInit: function() {
            var ref, ref1;
            // NOTE: Arbitrary timeout set here. Can we get the video before slider
            // init as it is firing before?
            var timeoutId = setTimeout(function() {
                playVideo();
            }, 1000);
            setTimeoutId(timeoutId);
            if ((ref = covers === null || covers === void 0 ? void 0 : covers[0].acfHighlightCover) === null || ref === void 0 ? void 0 : (ref1 = ref.covers) === null || ref1 === void 0 ? void 0 : ref1.length) {
                var ref2, ref3;
                var ref4 = (ref2 = covers === null || covers === void 0 ? void 0 : covers[0].acfHighlightCover) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.covers) === null || ref3 === void 0 ? void 0 : ref3[0], uiColour = ref4.uiColour, uiColourMobile = ref4.uiColourMobile;
                setSliderColour(uiColour);
                setSliderMobileColour(uiColourMobile);
            }
        },
        beforeChange: function(oldIndex, newIndex) {
            var ref, ref1, ref2;
            setProgress(newIndex / (setSliderLength - 1) * 100);
            if (covers === null || covers === void 0 ? void 0 : (ref = covers[newIndex]) === null || ref === void 0 ? void 0 : (ref1 = ref.acfHighlightCover) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.covers) === null || ref2 === void 0 ? void 0 : ref2.length) {
                var ref3, ref4;
                var ref5 = (ref3 = covers === null || covers === void 0 ? void 0 : covers[newIndex].acfHighlightCover) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.covers) === null || ref4 === void 0 ? void 0 : ref4[0], uiColour = ref5.uiColour, uiColourMobile = ref5.uiColourMobile;
                setSliderColour(uiColour);
                setSliderMobileColour(uiColourMobile);
            }
        },
        afterChange: function(index) {
            playVideo();
        }
    };
    // NOTE: We should really be using refs instead of query selector
    // to acceess videos.
    var getVideo = function(video) {
        if (video) {
            var promiseVideo = video.play();
            if (promiseVideo !== undefined) {
                promiseVideo.catch(function(error) {
                    console.log("video error: ", error);
                }).then(function() {
                    var ref;
                    sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPause();
                });
            }
        }
    };
    var playVideo = function() {
        if (true) {
            var videos = document.querySelectorAll(".slick-slide.slick-active video");
            getVideo(videos[0], !isDesktop);
            getVideo(videos[1], isDesktop);
        }
    };
    var handleVideoEnded = function() {
        var ref, ref1;
        if (true) {
            var videos = document.querySelectorAll(".slick-slide:not(.slick-active) video");
            // SEL-26 - Some how one user that seems to have this blinking page open forever is now killing sentry because videos.forEach() doesn't exist
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(!videos, NodeList)) {
                return;
            }
            var videoTimeoutId = setTimeout(function() {
                videos.forEach(function(video) {
                    video.load();
                });
            }, 1000);
            setVideoTimeoutId(videoTimeoutId);
        }
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext();
        sliderRef === null || sliderRef === void 0 ? void 0 : (ref1 = sliderRef.current) === null || ref1 === void 0 ? void 0 : ref1.slickPlay();
    };
    var setLink = function(slug, children) {
        var decideLink = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        return !decideLink && !noLink && slug ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            type: "Highlight",
            href: slug,
            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().link),
            children: children
        }) : children;
    };
    var decideMedia = function(videos, images, className) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CloudinaryMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().media), className),
            videos: videos,
            videoAutoplay: false,
            videoEnded: function() {
                return handleVideoEnded();
            },
            images: images,
            noLazy: true
        });
    };
    var setContent = function(videosMobile, videosDesktop, images, title, description) {
        var slug = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", decideLink = arguments.length > 6 ? arguments[6] : void 0, gender = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", modelSlug = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : "";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().slide),
            children: [
                setLink(slug, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        videosMobile && decideMedia(videosMobile, images, (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mediaMobile)),
                        videosDesktop && decideMedia(videosDesktop, images, (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mediaDesktop))
                    ]
                }), decideLink),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().info),
                    children: [
                        title && modelSlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            type: "Model",
                            href: modelSlug,
                            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().link),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().title),
                                dangerouslySetInnerHTML: {
                                    __html: title
                                }
                            })
                        }),
                        description && setLink(slug, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().description),
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        }), decideLink)
                    ]
                })
            ]
        }, "".concat(description, "_").concat(title, "_").concat(slug));
    };
    var setVideos = function(mobile, desktop) {
        var mobileUrl = mobile === null || mobile === void 0 ? void 0 : mobile.mediaItemUrl;
        var mobileType = mobile === null || mobile === void 0 ? void 0 : mobile.mimeType;
        var desktopUrl = desktop === null || desktop === void 0 ? void 0 : desktop.mediaItemUrl;
        var desktopType = desktop === null || desktop === void 0 ? void 0 : desktop.mimeType;
        return [
            mobileUrl ? {
                url: mobileUrl,
                type: mobileType
            } : undefined,
            desktopUrl ? {
                url: desktopUrl,
                type: desktopType
            } : undefined, 
        ].filter(function(x) {
            return x !== undefined;
        });
    };
    var setImages = function(mobile, desktop) {
        var mobileUrl = mobile === null || mobile === void 0 ? void 0 : mobile.mediaItemUrl;
        var desktopUrl = desktop === null || desktop === void 0 ? void 0 : desktop.mediaItemUrl;
        return [
            mobileUrl ? {
                url: mobileUrl,
                params: "f_auto"
            } : undefined,
            desktopUrl ? {
                url: desktopUrl,
                params: "f_auto"
            } : undefined, 
        ].filter(function(x) {
            return x !== undefined;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().container), className),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mainTitleContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().mainTitle),
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SliderBlock__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                parentRef: sliderRef,
                setKey: (ref = router.query) === null || ref === void 0 ? void 0 : ref.boardSlug,
                settings: sliderSettings,
                children: covers === null || covers === void 0 ? void 0 : covers.map(function(param, i) {
                    var acfBlocks = param.acfBlocks, acfHighlightCover = param.acfHighlightCover, acfHighlightSettings = param.acfHighlightSettings, slug = param.slug;
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    if (!(acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.covers) || (acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : (ref = acfHighlightCover.covers) === null || ref === void 0 ? void 0 : ref.length) < 1) return null;
                    var ref6 = acfHighlightCover.covers[0], videoMobile = ref6.videoMobile, videoMobileWebm = ref6.videoMobileWebm, videoDesktop = ref6.videoDesktop, videoDesktopWebm = ref6.videoDesktopWebm, imageMobile = ref6.imageMobile, imageDesktop = ref6.imageDesktop;
                    var title = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref1 = acfHighlightSettings.models) === null || ref1 === void 0 ? void 0 : ref1.title;
                    var modelSlug = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref2 = acfHighlightSettings.models) === null || ref2 === void 0 ? void 0 : ref2.slug;
                    var description = acfHighlightCover === null || acfHighlightCover === void 0 ? void 0 : acfHighlightCover.shortDescription;
                    var decideLink = ((ref3 = acfBlocks.contentBlocks) === null || ref3 === void 0 ? void 0 : ref3.length) < 1;
                    var gender = acfHighlightSettings === null || acfHighlightSettings === void 0 ? void 0 : (ref4 = acfHighlightSettings.models) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.acfModel) === null || ref5 === void 0 ? void 0 : ref5.gender;
                    return setContent(setVideos(videoMobileWebm, videoMobile), setVideos(videoDesktopWebm, videoDesktop), setImages(imageMobile, imageDesktop), title, coverTitle || description, slug, decideLink, gender, title ? modelSlug : null);
                })
            }),
            covers.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().progressBar),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_SliderCover_module_css__WEBPACK_IMPORTED_MODULE_10___default().progressBarIndicator),
                    style: {
                        width: "".concat(progress, "%")
                    }
                })
            })
        ]
    });
}
SliderCover.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    covers: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().array),
    coverTitle: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    noLink: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string)
};
SliderCover.defaultProps = {
    title: "",
    covers: [],
    coverTitle: "",
    noLink: false,
    className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (SliderCover);


/***/ }),

/***/ 1610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var html_entities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9111);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7821);
/* harmony import */ var helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(406);
/* harmony import */ var _helpers_isModellinkSite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2084);








var htmlEntities = new html_entities__WEBPACK_IMPORTED_MODULE_3__/* .Html5Entities */ .JK();
function htmlDecode() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return htmlEntities.decode(string);
}
function WordpressSEO(param) {
    var url = param.url, title = param.title, seo = param.seo, image = param.image, desc = param.desc, _canonical = param.canonical, canonical = _canonical === void 0 ? null : _canonical;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var siteName;
    var fallbackTitle;
    var siteLogo;
    if ((0,_helpers_isModellinkSite__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)()) {
        siteName = "Modellink";
        fallbackTitle = "".concat(htmlDecode(title), " | ").concat(siteName);
        siteLogo = "/img/logo/modellink.jpg";
    } else {
        var ref2;
        siteName = "Select Model Management";
        fallbackTitle = "".concat(htmlDecode(title)).concat(((ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.site) ? " | Select ".concat((0,helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(router.query.site)) : "", " | ").concat(siteName);
        siteLogo = "/img/logo/selectmodel.jpg";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: seo && seo.title ? htmlDecode(seo.title) : fallbackTitle,
        description: (seo === null || seo === void 0 ? void 0 : seo.metaDesc) || desc || siteName,
        openGraph: {
            title: seo === null || seo === void 0 ? void 0 : seo.title,
            url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LIVE_SITE_URL */ .WJ).concat(url),
            description: seo === null || seo === void 0 ? void 0 : seo.metaDesc,
            images: [
                {
                    url: image || (seo === null || seo === void 0 ? void 0 : (ref = seo.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .LIVE_SITE_URL */ .WJ).concat(siteLogo)
                }, 
            ]
        },
        canonical: canonical
    });
}
WordpressSEO.propTypes = {
    url: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    desc: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    image: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    canonical: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    seo: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
WordpressSEO.defaultProps = {
    url: "",
    title: "",
    desc: null,
    image: "",
    seo: {},
    canonical: null
};
/* harmony default export */ __webpack_exports__["Z"] = (WordpressSEO);


/***/ }),

/***/ 406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uppercaseFirst; }
/* harmony export */ });
function uppercaseFirst(string) {
    if (!string) return null;
    return "".concat(string.charAt(0).toUpperCase()).concat(string.substring(1));
}


/***/ }),

/***/ 662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClearTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useClearTimeout(id) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            clearTimeout(id);
        };
    }, [
        id
    ]);
}


/***/ }),

/***/ 2581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _boardSlug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(3967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Layout/index.js + 1 modules
var Layout = __webpack_require__(3825);
// EXTERNAL MODULE: ./components/WordpressSEO/index.js
var WordpressSEO = __webpack_require__(1610);
// EXTERNAL MODULE: ./components/SliderCover/index.js
var SliderCover = __webpack_require__(6653);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./components/ModelList/ModelListModel/index.js
var ModelListModel = __webpack_require__(4730);
// EXTERNAL MODULE: ./components/ModelList/ModelList.module.css
var ModelList_module = __webpack_require__(1064);
var ModelList_module_default = /*#__PURE__*/__webpack_require__.n(ModelList_module);
;// CONCATENATED MODULE: ./components/ModelList/index.js







function ModelList(param) {
    var models = param.models, group = param.group, boardSlug = param.boardSlug, showFollowers = param.showFollowers;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModelList_module_default()).container,
                children: models.length > 0 && models.filter(function(param) {
                    var image = param.image;
                    return (image === null || image === void 0 ? void 0 : image.defaultColor) !== "false";
                }).map(function(model) {
                    return /*#__PURE__*/ (0,react.createElement)(ModelListModel/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, model), {
                        key: model.id,
                        group: group,
                        href: "".concat(group, "/").concat(boardSlug, "/").concat(model.slug),
                        withBoard: true,
                        showFollowers: showFollowers
                    }));
                })
            }),
            models.length < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ModelList_module_default()).noItems,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "We do not currently have any models matching your requested criteria"
                })
            })
        ]
    });
}
ModelList.propTypes = {
    models: (prop_types_default()).array,
    group: (prop_types_default()).string,
    showFollowers: (prop_types_default()).bool
};
ModelList.defaultProps = {
    models: [],
    group: "",
    showFollowers: false
};
/* harmony default export */ var components_ModelList = (ModelList);

// EXTERNAL MODULE: ./components/ToggleField/ToggleField.module.css
var ToggleField_module = __webpack_require__(8951);
var ToggleField_module_default = /*#__PURE__*/__webpack_require__.n(ToggleField_module);
;// CONCATENATED MODULE: ./components/ToggleField/index.js





function ToggleField(param) {
    var children = param.children, className = param.className, toggled = param.toggled, onChange = param.onChange;
    if (!children) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: classnames_default()(className, (ToggleField_module_default()).container, (0,_define_property/* default */.Z)({}, (ToggleField_module_default()).toggled, toggled)),
        onClick: onChange,
        children: children
    });
}
ToggleField.propTypes = {
    className: (prop_types_default()).string,
    toggled: (prop_types_default()).bool,
    onChange: (prop_types_default()).func
};
ToggleField.defaultProps = {
    className: "",
    children: null,
    toggled: false,
    onChange: function() {}
};
/* harmony default export */ var components_ToggleField = (ToggleField);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(8509);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(7821);
// EXTERNAL MODULE: ./hooks/useClearTimeout.js
var useClearTimeout = __webpack_require__(662);
// EXTERNAL MODULE: ./components/BoardsToggle/BoardsToggle.module.css
var BoardsToggle_module = __webpack_require__(3551);
var BoardsToggle_module_default = /*#__PURE__*/__webpack_require__.n(BoardsToggle_module);
;// CONCATENATED MODULE: ./components/BoardsToggle/index.js










function BoardsMenu(param) {
    var boardToggled = param.boardToggled, handleBoardToggle = param.handleBoardToggle, handleFollowersToggle = param.handleFollowersToggle, handleTownToggled = param.handleTownToggled, className = param.className, site = param.site;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)("Share Board"), shareText = ref[0], setShareText = ref[1];
    var ref1 = (0,react.useState)(null), timeoutId = ref1[0], setTimeoutId = ref1[1];
    (0,useClearTimeout/* default */.Z)(timeoutId);
    (0,react.useEffect)(function() {
        if (boardToggled) {
            (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)();
        } else {
            (0,bodyScrollLock_esm/* clearAllBodyScrollLocks */.tP)();
        }
        return function() {
            return (0,bodyScrollLock_esm/* clearAllBodyScrollLocks */.tP)();
        };
    }, [
        boardToggled
    ]);
    var pageLink = "".concat(constants/* LIVE_SITE_URL */.WJ).concat(router.asPath);
    var handleShare = function() {
        var copyLink = document.getElementById("board-share-link");
        copyLink.select();
        document.execCommand("copy");
        setShareText("Link copied");
        var timeoutId = setTimeout(function() {
            setShareText("Share Board");
        }, 1000);
        setTimeoutId(timeoutId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((BoardsToggle_module_default()).container, className, (0,_define_property/* default */.Z)({}, (BoardsToggle_module_default()).containerToggled, boardToggled === true)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (BoardsToggle_module_default()).btn,
                        onClick: handleBoardToggle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BoardsToggle_module_default()).menu,
                        children: [
                            ![
                                "london",
                                "milano"
                            ].includes(site) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((BoardsToggle_module_default()).menuItem, (BoardsToggle_module_default()).mobileOnly),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (BoardsToggle_module_default()).toggle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            onClick: handleTownToggled
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (BoardsToggle_module_default()).menuLabel,
                                            children: "In Town"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BoardsToggle_module_default()).menuItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (BoardsToggle_module_default()).toggle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            onClick: handleFollowersToggle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (BoardsToggle_module_default()).menuLabel,
                                            children: "Show followers"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BoardsToggle_module_default()).menuItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: (BoardsToggle_module_default()).shareBtn,
                                    onClick: handleShare,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (BoardsToggle_module_default()).menuLabel,
                                            children: shareText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "board-share-link",
                                            className: (BoardsToggle_module_default()).shareLink,
                                            type: "text",
                                            defaultValue: pageLink
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (BoardsToggle_module_default()).overlay,
                onClick: handleBoardToggle
            })
        ]
    });
}
BoardsMenu.propTypes = {
    boardToggled: (prop_types_default()).bool,
    handleBoardToggle: (prop_types_default()).func,
    handleFollowersToggle: (prop_types_default()).func,
    handleTownToggled: (prop_types_default()).func,
    className: (prop_types_default()).string,
    site: (prop_types_default()).string
};
BoardsMenu.defaultProps = {
    boardToggled: false,
    handleBoardToggle: function() {},
    handleFollowersToggle: function() {},
    handleTownToggled: function() {},
    className: ""
};
/* harmony default export */ var BoardsToggle = (BoardsMenu);

// EXTERNAL MODULE: ./components/BackButton/index.js
var BackButton = __webpack_require__(7879);
// EXTERNAL MODULE: ./components/Link/index.js + 1 modules
var Link = __webpack_require__(5641);
// EXTERNAL MODULE: ./components/BoardsMenu/BoardsMenu.module.css
var BoardsMenu_module = __webpack_require__(3958);
var BoardsMenu_module_default = /*#__PURE__*/__webpack_require__.n(BoardsMenu_module);
;// CONCATENATED MODULE: ./components/BoardsMenu/index.js










function BoardsMenu_BoardsMenu(param) {
    var className = param.className, boards = param.boards, boardType = param.boardType, site = param.site, currentBoard = param.currentBoard, boardToggled = param.boardToggled, handleBoardToggle = param.handleBoardToggle, inTownToggled = param.inTownToggled, toggleInTown = param.toggleInTown, handleFollowersToggle = param.handleFollowersToggle;
    var ref = (0,react.useState)(false), dropdown = ref[0], setDropdown = ref[1];
    var setBoards = function() {
        var classname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classname,
            children: boards// .filter(({ slug }) => slug !== currentBoard)
            .map(function(param) {
                var slug = param.slug, id = param.id, title = param.title;
                var matchingUrl = slug === currentBoard;
                return /*#__PURE__*/ react.createElement(matchingUrl ? "h1" : "h2", {
                    className: classnames_default()((BoardsMenu_module_default()).link, (0,_define_property/* default */.Z)({}, (BoardsMenu_module_default()).linkActive, matchingUrl)),
                    key: id
                }, /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "".concat(boardType, "/").concat(slug),
                    type: "Board",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: title === "All" && boards.length === 1 ? "".concat(boardType.charAt(0).toUpperCase()).concat(boardType.substring(1)) : title
                        }
                    })
                }));
            })
        });
    };
    var handleDropdown = function() {
        setDropdown(!dropdown);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BoardsMenu_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                        fallback: "".concat(site, "/").concat(boardType)
                    }),
                    ![
                        "london",
                        "milano"
                    ].includes(site) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ToggleField, {
                        className: (BoardsMenu_module_default()).inTownToggle,
                        onChange: toggleInTown,
                        toggled: inTownToggled,
                        children: "In Town"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: classnames_default()((BoardsMenu_module_default()).dropdownBtn, (0,_define_property/* default */.Z)({}, (BoardsMenu_module_default()).dropdownBtnExpanded, dropdown)),
                        onClick: handleDropdown,
                        children: currentBoard || boardType
                    }),
                    setBoards((BoardsMenu_module_default()).boardsDesktop),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardsToggle, {
                        className: (BoardsMenu_module_default()).toggle,
                        boardToggled: boardToggled,
                        handleBoardToggle: handleBoardToggle,
                        handleFollowersToggle: handleFollowersToggle,
                        handleTownToggled: toggleInTown,
                        site: site
                    })
                ]
            }),
            setBoards(classnames_default()((BoardsMenu_module_default()).boardsMobile, (0,_define_property/* default */.Z)({}, (BoardsMenu_module_default()).boardsVisible, dropdown)))
        ]
    });
}
BoardsMenu_BoardsMenu.propTypes = {
    className: (prop_types_default()).string,
    boards: (prop_types_default()).array,
    boardType: (prop_types_default()).string,
    site: (prop_types_default()).string,
    currentBoard: (prop_types_default()).string,
    boardToggled: (prop_types_default()).bool,
    handleBoardToggle: (prop_types_default()).func,
    inTownToggled: (prop_types_default()).bool,
    toggleInTown: (prop_types_default()).func,
    handleFollowersToggle: (prop_types_default()).func
};
BoardsMenu_BoardsMenu.defaultProps = {
    className: "",
    boards: [],
    boardType: "",
    site: "",
    currentBoard: "",
    boardToggled: false,
    handleBoardToggle: function() {},
    inTownToggled: false,
    toggleInTown: function() {},
    handleFollowersToggle: function() {}
};
/* harmony default export */ var components_BoardsMenu = (BoardsMenu_BoardsMenu);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./components/BoardsAlphabeticalFilter/BoardsAlphabeticalFilter.module.css
var BoardsAlphabeticalFilter_module = __webpack_require__(4824);
var BoardsAlphabeticalFilter_module_default = /*#__PURE__*/__webpack_require__.n(BoardsAlphabeticalFilter_module);
;// CONCATENATED MODULE: ./components/BoardsAlphabeticalFilter/index.js






function BoardsAlphabeticalFilter(param) {
    var models = param.models, setFilter = param.setFilter, activeFilter = param.activeFilter;
    var firstNameLetters = (0,_to_consumable_array/* default */.Z)(new Set(models.map(function(m) {
        return m.firstName.charAt(0);
    })));
    var filters = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BoardsAlphabeticalFilter_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    return setFilter(null);
                },
                className: classnames_default()((BoardsAlphabeticalFilter_module_default()).filter, (0,_define_property/* default */.Z)({}, (BoardsAlphabeticalFilter_module_default()).filterActive, activeFilter === null)),
                children: "All"
            }),
            filters.map(function(filter) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: function() {
                        return setFilter(filter);
                    },
                    className: classnames_default()((BoardsAlphabeticalFilter_module_default()).filter, (0,_define_property/* default */.Z)({}, (BoardsAlphabeticalFilter_module_default()).filterInactive, !firstNameLetters.includes(filter)), (0,_define_property/* default */.Z)({}, (BoardsAlphabeticalFilter_module_default()).filterActive, activeFilter === filter)),
                    children: filter
                }, filter);
            })
        ]
    });
}
BoardsAlphabeticalFilter.propTypes = {
    models: (prop_types_default()).array,
    setFilter: (prop_types_default()).func,
    activeFilter: (prop_types_default()).string
};
BoardsAlphabeticalFilter.defaultProps = {
    models: [],
    setFilter: function() {},
    activeFilter: ""
};
/* harmony default export */ var components_BoardsAlphabeticalFilter = (BoardsAlphabeticalFilter);

// EXTERNAL MODULE: ./pages/[site]/[boardType]/[boardSlug]/board.module.css
var board_module = __webpack_require__(1737);
var board_module_default = /*#__PURE__*/__webpack_require__.n(board_module);
;// CONCATENATED MODULE: ./pages/[site]/[boardType]/[boardSlug]/index.js












function Board(param) {
    var title = param.title, seo = param.seo, acfModelBoardsCover = param.acfModelBoardsCover, boards = param.boards, boardUri = param.boardUri, boardType = param.boardType, boardSlug = param.boardSlug, site = param.site, globalSettings = param.globalSettings, models = param.models;
    var covers = (acfModelBoardsCover === null || acfModelBoardsCover === void 0 ? void 0 : acfModelBoardsCover.highlightOrder) || null;
    var boardUrl = "".concat(boardType).concat(boardSlug ? "/".concat(boardSlug) : "");
    var ref = (0,react.useState)(false), boardToggled = ref[0], setBoardToggled = ref[1];
    var ref1 = (0,react.useState)(false), showFollowers = ref1[0], setShowFollowers = ref1[1];
    var ref2 = (0,react.useState)(false), inTownOnly = ref2[0], setInTownOnly = ref2[1];
    var ref3 = (0,react.useState)(null), activeFilter = ref3[0], setActiveFilter = ref3[1];
    var handleBoardToggle = function() {
        setBoardToggled(!boardToggled);
    };
    var handleFollowersToggle = function() {
        setShowFollowers(!showFollowers);
    };
    (0,react.useEffect)(function() {
        setActiveFilter(null);
    }, [
        boardUrl
    ]);
    var setBoardsMenu = function() {
        var classname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BoardsMenu, {
            className: classname,
            currentBoard: boardSlug,
            boards: boards,
            site: site,
            boardType: boardType,
            boardToggled: boardToggled,
            handleBoardToggle: handleBoardToggle,
            inTownToggled: inTownOnly,
            toggleInTown: function() {
                return setInTownOnly(!inTownOnly);
            },
            handleFollowersToggle: handleFollowersToggle
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WordpressSEO/* default */.Z, {
                url: "/".concat(site, "/").concat(boardType, "/").concat(boardSlug),
                seo: seo,
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((board_module_default()).container, (0,_define_property/* default */.Z)({}, (board_module_default()).containerTopSpacing, !covers)),
                children: [
                    setBoardsMenu((board_module_default()).boardsMenuMobile),
                    covers && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderCover/* default */.Z, {
                        className: (board_module_default()).slider,
                        covers: covers
                    }),
                    setBoardsMenu((board_module_default()).boardsMenu),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModelList, {
                        group: boardType,
                        boardSlug: boardSlug,
                        models: activeFilter || inTownOnly ? models.filter(function(m) {
                            if (inTownOnly && !m.inTown) return false;
                            if (!activeFilter) return true;
                            return m.firstName.charAt(0).toUpperCase() === activeFilter;
                        }) : models,
                        showFollowers: showFollowers
                    }),
                    models.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BoardsAlphabeticalFilter, {
                        models: models,
                        activeFilter: activeFilter,
                        setFilter: function(f) {
                            return setActiveFilter(f);
                        }
                    })
                ]
            })
        ]
    });
}
Board.propTypes = {
    seo: (prop_types_default()).object,
    boards: (prop_types_default()).array,
    boardUri: (prop_types_default()).string,
    boardType: (prop_types_default()).string,
    boardSlug: (prop_types_default()).string,
    site: (prop_types_default()).string,
    globalSettings: (prop_types_default()).object
};
Board.defaultProps = {
    seo: {},
    boards: [],
    boardUri: "",
    boardType: "",
    boardSlug: "",
    site: "",
    globalSettings: {}
};
var __N_SSG = true;
/* harmony default export */ var _boardSlug_ = (Board);


/***/ }),

/***/ 6749:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"BackButton_spacing--xxxs__gjTE3","spacing--xxs":"BackButton_spacing--xxs__rSADE","spacing--xs":"BackButton_spacing--xs__8FF69","spacing--sm":"BackButton_spacing--sm___Bx45","spacing--md":"BackButton_spacing--md__AjHcV","spacing--lg":"BackButton_spacing--lg__3JElb","spacing--xl":"BackButton_spacing--xl__UL58X","spacing--xxl":"BackButton_spacing--xxl__wKmK5","spacing--xxxl":"BackButton_spacing--xxxl__HTVAR","container":"BackButton_container__8wlKy","btn":"BackButton_btn__T6gpu","fadeInItems":"BackButton_fadeInItems__MtLQK"};

/***/ }),

/***/ 4824:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"BoardsAlphabeticalFilter_spacing--xxxs__kUGQv","spacing--xxs":"BoardsAlphabeticalFilter_spacing--xxs___7sJJ","spacing--xs":"BoardsAlphabeticalFilter_spacing--xs__EhZSH","spacing--sm":"BoardsAlphabeticalFilter_spacing--sm__hbJU8","spacing--md":"BoardsAlphabeticalFilter_spacing--md__VqsN_","spacing--lg":"BoardsAlphabeticalFilter_spacing--lg__vWob0","spacing--xl":"BoardsAlphabeticalFilter_spacing--xl__y3mpV","spacing--xxl":"BoardsAlphabeticalFilter_spacing--xxl__B45GC","spacing--xxxl":"BoardsAlphabeticalFilter_spacing--xxxl__8ypW6","container":"BoardsAlphabeticalFilter_container__KzNj4","filter":"BoardsAlphabeticalFilter_filter__vh3pN","filterActive":"BoardsAlphabeticalFilter_filterActive__Aw5ei","filterInactive":"BoardsAlphabeticalFilter_filterInactive__0Jf5c","fadeInItems":"BoardsAlphabeticalFilter_fadeInItems__OW_gL"};

/***/ }),

/***/ 3958:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"BoardsMenu_spacing--xxxs__cmxHz","spacing--xxs":"BoardsMenu_spacing--xxs__SZRSt","spacing--xs":"BoardsMenu_spacing--xs__fYeNX","spacing--sm":"BoardsMenu_spacing--sm__d7UpK","spacing--md":"BoardsMenu_spacing--md__9ovxX","spacing--lg":"BoardsMenu_spacing--lg__p9PAt","spacing--xl":"BoardsMenu_spacing--xl__0o536","spacing--xxl":"BoardsMenu_spacing--xxl__hNJ_S","spacing--xxxl":"BoardsMenu_spacing--xxxl__vz98T","container":"BoardsMenu_container__0Kw59","dropdownBtn":"BoardsMenu_dropdownBtn__l6KXk","dropdownBtnExpanded":"BoardsMenu_dropdownBtnExpanded__1I0N6","boardsVisible":"BoardsMenu_boardsVisible__lw6fl","boardsMobile":"BoardsMenu_boardsMobile__w3f4s","link":"BoardsMenu_link__o_Fis","boardsDesktop":"BoardsMenu_boardsDesktop__3j104","inTownToggle":"BoardsMenu_inTownToggle__LYVia","toggle":"BoardsMenu_toggle__u82sr","linkActive":"BoardsMenu_linkActive__aAyS7","fadeInItems":"BoardsMenu_fadeInItems__x_h_n"};

/***/ }),

/***/ 3551:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"BoardsToggle_spacing--xxxs__I6vUq","spacing--xxs":"BoardsToggle_spacing--xxs__46fUY","spacing--xs":"BoardsToggle_spacing--xs__OXMEa","spacing--sm":"BoardsToggle_spacing--sm__XwRje","spacing--md":"BoardsToggle_spacing--md__lgiqW","spacing--lg":"BoardsToggle_spacing--lg__hCg_j","spacing--xl":"BoardsToggle_spacing--xl__o_bcI","spacing--xxl":"BoardsToggle_spacing--xxl__dm0kJ","spacing--xxxl":"BoardsToggle_spacing--xxxl__rBe3C","container":"BoardsToggle_container__HlUdU","containerToggled":"BoardsToggle_containerToggled__E83_V","overlay":"BoardsToggle_overlay__NgnCC","menu":"BoardsToggle_menu__Ybt7P","btn":"BoardsToggle_btn__2vRmy","menuItem":"BoardsToggle_menuItem__wuJyr","mobileOnly":"BoardsToggle_mobileOnly__OLmHv","toggle":"BoardsToggle_toggle__V_fw4","shareBtn":"BoardsToggle_shareBtn__CcZaV","menuLabel":"BoardsToggle_menuLabel__htaND","fadeInItems":"BoardsToggle_fadeInItems__PoPKS"};

/***/ }),

/***/ 4027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"CloudinaryImage_spacing--xxxs__QtiOI","spacing--xxs":"CloudinaryImage_spacing--xxs___RX_E","spacing--xs":"CloudinaryImage_spacing--xs__CjZ0m","spacing--sm":"CloudinaryImage_spacing--sm__ltlHy","spacing--md":"CloudinaryImage_spacing--md__C3K8W","spacing--lg":"CloudinaryImage_spacing--lg__8XDbe","spacing--xl":"CloudinaryImage_spacing--xl__sGgGs","spacing--xxl":"CloudinaryImage_spacing--xxl__JD0JD","spacing--xxxl":"CloudinaryImage_spacing--xxxl__j_4Vl","container":"CloudinaryImage_container__nIIa7","loaded":"CloudinaryImage_loaded__hSSNW","fadeInItems":"CloudinaryImage_fadeInItems__lFZVD"};

/***/ }),

/***/ 1130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"CloudinaryMedia_spacing--xxxs__8hhoO","spacing--xxs":"CloudinaryMedia_spacing--xxs__jAN_O","spacing--xs":"CloudinaryMedia_spacing--xs__mCgCD","spacing--sm":"CloudinaryMedia_spacing--sm__fmlUT","spacing--md":"CloudinaryMedia_spacing--md__zi9QH","spacing--lg":"CloudinaryMedia_spacing--lg__3we4U","spacing--xl":"CloudinaryMedia_spacing--xl__5KxO2","spacing--xxl":"CloudinaryMedia_spacing--xxl__D_5z8","spacing--xxxl":"CloudinaryMedia_spacing--xxxl__wkGzl","container":"CloudinaryMedia_container__TSo9k","fadeInItems":"CloudinaryMedia_fadeInItems__9lezI"};

/***/ }),

/***/ 3725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"CloudinaryVideo_spacing--xxxs__rdnL_","spacing--xxs":"CloudinaryVideo_spacing--xxs__cmhu_","spacing--xs":"CloudinaryVideo_spacing--xs__kSj9Z","spacing--sm":"CloudinaryVideo_spacing--sm__jRoRD","spacing--md":"CloudinaryVideo_spacing--md__xPkE4","spacing--lg":"CloudinaryVideo_spacing--lg__pHjBA","spacing--xl":"CloudinaryVideo_spacing--xl__a_9qS","spacing--xxl":"CloudinaryVideo_spacing--xxl__wRN68","spacing--xxxl":"CloudinaryVideo_spacing--xxxl__mpwWX","container":"CloudinaryVideo_container__Ok78r","loaded":"CloudinaryVideo_loaded__L7h4n","mobile":"CloudinaryVideo_mobile__FsYJz","desktop":"CloudinaryVideo_desktop__4kB4o","fadeInItems":"CloudinaryVideo_fadeInItems__zGGsJ"};

/***/ }),

/***/ 1627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"Layout_spacing--xxxs__8iHw7","spacing--xxs":"Layout_spacing--xxs__rg8b2","spacing--xs":"Layout_spacing--xs__dO6OG","spacing--sm":"Layout_spacing--sm__jhGe9","spacing--md":"Layout_spacing--md__vIpF7","spacing--lg":"Layout_spacing--lg__fEe2_","spacing--xl":"Layout_spacing--xl__dhV28","spacing--xxl":"Layout_spacing--xxl__K3sH1","spacing--xxxl":"Layout_spacing--xxxl__Bs9tG","main":"Layout_main__gbdP0","fadeInItems":"Layout_fadeInItems__QzPHk"};

/***/ }),

/***/ 1064:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ModelList_spacing--xxxs__06zU8","spacing--xxs":"ModelList_spacing--xxs__3enar","spacing--xs":"ModelList_spacing--xs__E2XxM","spacing--sm":"ModelList_spacing--sm__Jargb","spacing--md":"ModelList_spacing--md__EMI1t","spacing--lg":"ModelList_spacing--lg__e_QxN","spacing--xl":"ModelList_spacing--xl__JMUaK","spacing--xxl":"ModelList_spacing--xxl___EXQj","spacing--xxxl":"ModelList_spacing--xxxl__GCPxq","noItems":"ModelList_noItems__DuSPj","container":"ModelList_container__M5wi2","fadeInItems":"ModelList_fadeInItems__WY7qu"};

/***/ }),

/***/ 5193:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"OutdatedBrowser_spacing--xxxs__Accab","spacing--xxs":"OutdatedBrowser_spacing--xxs__i92K8","spacing--xs":"OutdatedBrowser_spacing--xs__zWpQI","spacing--sm":"OutdatedBrowser_spacing--sm__Vrmq_","spacing--md":"OutdatedBrowser_spacing--md__vcPS_","spacing--lg":"OutdatedBrowser_spacing--lg__SYnnw","spacing--xl":"OutdatedBrowser_spacing--xl__Mc5r2","spacing--xxl":"OutdatedBrowser_spacing--xxl___59QJ","spacing--xxxl":"OutdatedBrowser_spacing--xxxl__S_A_A","container":"OutdatedBrowser_container__5_uvZ","title":"OutdatedBrowser_title___0088","text":"OutdatedBrowser_text__aSnM3","link":"OutdatedBrowser_link__HM2Bc","btn":"OutdatedBrowser_btn__r3Ac0","fadeInItems":"OutdatedBrowser_fadeInItems__7725t"};

/***/ }),

/***/ 7764:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"SliderCover_spacing--xxxs__iTqjK","spacing--xxs":"SliderCover_spacing--xxs__egwaf","spacing--xs":"SliderCover_spacing--xs__SOxLb","spacing--sm":"SliderCover_spacing--sm__SX4yx","spacing--md":"SliderCover_spacing--md__3HmPV","spacing--lg":"SliderCover_spacing--lg__DhAWQ","spacing--xl":"SliderCover_spacing--xl__0HHQy","spacing--xxl":"SliderCover_spacing--xxl__3jSb0","spacing--xxxl":"SliderCover_spacing--xxxl__0Y4_u","container":"SliderCover_container__d975A","media":"SliderCover_media__JFSSf","mediaMobile":"SliderCover_mediaMobile__IwxPg","mediaDesktop":"SliderCover_mediaDesktop__FXPIt","link":"SliderCover_link__TJc_r","info":"SliderCover_info__MYH7r","mainTitleContainer":"SliderCover_mainTitleContainer__IBGLI","mainTitle":"SliderCover_mainTitle__FXnyj","title":"SliderCover_title__p3AWD","description":"SliderCover_description__Msijt","progressBar":"SliderCover_progressBar__PNbyG","progressBarIndicator":"SliderCover_progressBarIndicator__RWFiS","fadeInItems":"SliderCover_fadeInItems__T0O7m"};

/***/ }),

/***/ 8951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"ToggleField_spacing--xxxs__O7Nc8","spacing--xxs":"ToggleField_spacing--xxs__7Pde_","spacing--xs":"ToggleField_spacing--xs__yM7wT","spacing--sm":"ToggleField_spacing--sm__Hyyth","spacing--md":"ToggleField_spacing--md__y2TFW","spacing--lg":"ToggleField_spacing--lg__5109e","spacing--xl":"ToggleField_spacing--xl__LAIhW","spacing--xxl":"ToggleField_spacing--xxl__Cvfgu","spacing--xxxl":"ToggleField_spacing--xxxl__bxA1b","container":"ToggleField_container__AEHVA","toggled":"ToggleField_toggled__7jTW8","fadeInItems":"ToggleField_fadeInItems__qfaWx"};

/***/ }),

/***/ 1737:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"board_spacing--xxxs__rAlwN","spacing--xxs":"board_spacing--xxs___s8_J","spacing--xs":"board_spacing--xs__LOxh1","spacing--sm":"board_spacing--sm__mR7Zn","spacing--md":"board_spacing--md__mRZdI","spacing--lg":"board_spacing--lg__pVKTr","spacing--xl":"board_spacing--xl__n0nj7","spacing--xxl":"board_spacing--xxl__MWlaO","spacing--xxxl":"board_spacing--xxxl__FcYWQ","layout":"board_layout__gGm_E","container":"board_container__vwlUk","containerTopSpacing":"board_containerTopSpacing__VRPGZ","boardsMenu":"board_boardsMenu__1vIPV","boardsMenuMobile":"board_boardsMenuMobile__3D82H","headerItem":"board_headerItem__mGMok","headerImage":"board_headerImage__ru61n","slider":"board_slider__4_J1w","slideBelowMenu":"board_slideBelowMenu__yfNeY","logo":"board_logo__NJqar","fadeInItems":"board_fadeInItems__nL_C7"};

/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,66,774,888,179], function() { return __webpack_exec__(862); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);